// src/contexts/geral/UserContext.js
import React, { createContext, useContext, useState } from 'react';
import { clearAuthStorage } from '../../utils/AuthStorage';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    //console.log("pega dados login");

    const stored = localStorage.getItem('userLogin2');
    //console.log("pegou dados login", stored);

    if (!stored) return null;

    try {
      return JSON.parse(stored);
    } catch (error) {
      console.error("Erro ao ler userLogin, limpando storage:", error);
      clearAuthStorage();
      return null;
    }
  });

  const logout = () => {
    clearAuthStorage();
    setUser(null);
  };

  return (
    <UserContext.Provider value={{ user, setUser, logout }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
